import React, {
  useEffect,
  ReactElement,
  useState,
  useCallback,
} from 'react';
import * as S from './style';
import { Label } from 'components';

export interface Props {
  inputName: string;
  value?: string;
  imageState: 'fulfilled' | 'rejected' | 'pending';
  onDeleteHandler?: () => void;
}

function ImageItem({
  inputName,
  value,
  imageState,
  onDeleteHandler,
}: Props): ReactElement {
  const [background, setBackground] = useState<string>();
  const [imgName, setImgName] = useState<string>();

  const onClickImageDelete = useCallback(
    () => {
      setBackground('');
      setImgName('');

      onDeleteHandler && onDeleteHandler();
    },
    [onDeleteHandler]
  );

  useEffect(() => {
    setBackground(value ?? '');
  }, [value]);

  useEffect(() => {
    setImgName(inputName ?? '');
  }, [inputName]);

  return (
    <S.ImageItemContainer>
      <S.Image background={background} opacity={imageState === 'rejected' ? 0.5 : 1} />
      <S.FileTitle>
        {`${imgName}`}
      </S.FileTitle>
      <S.FileState>
        {(() => {
          if (imageState === 'pending') {
            return <Label contents={'업로드 진행중'} color={'blue_opacity_500'} />
          }

          if (imageState === 'rejected') {
            return (
              <S.FileStateContainer>
                <Label contents={'업로드 불가'} color={'gray_neautral_600'}/>
                <S.DeleteButton onClick={onClickImageDelete}>사진 삭제</S.DeleteButton>
              </S.FileStateContainer>
            );
          }

          if (imageState === 'fulfilled') {
            return <S.DeleteButton onClick={onClickImageDelete}>사진 삭제</S.DeleteButton>
          }
        })()}
      </S.FileState>
    </S.ImageItemContainer>
  );
}

export default ImageItem;
